<template>
  <div class="layout-img">
    <div id="image001"></div>
  </div>
</template>

<script>
export default {
  props: {
    srcImage: {
      type: String
    },
    box: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {}
  },
  watch: {
    box: {
      handler (newValue, oldValue) {
        this.draw(this.box)
      },
      immediate: true
    }
  },
  created () {
    // this.draw()
  },
  methods: {
    drawCanvas () {},
    draw (boxs) {
      const img = document.createElement('img')
      img.src = this.srcImage
      img.onload = function () {
        if (document.getElementById('canvas001') !== null) {
          const d = document.getElementById('image001')
          const dNested = document.getElementById('canvas001')
          d.removeChild(dNested)
        }
        const canvas = document.createElement('canvas')
        canvas.setAttribute('id', 'canvas001')
        canvas.setAttribute('style', 'width:100%')
        const ctx = canvas.getContext('2d')
        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          0,
          0,
          canvas.width,
          canvas.height
        )
        ctx.strokeStyle = 'red'
        ctx.lineWidth = 2
        for (let index = 0; index < boxs.length; index++) {
          let startX = 0
          let startY = 0
          let width = 0
          let height = 0
          if (boxs[index].xmax > boxs[index].xmin) {
            startX = boxs[index].xmin
            startY = boxs[index].ymin
            width = Math.abs(boxs[index].xmax - boxs[index].xmin)
            height = Math.abs(boxs[index].ymax - boxs[index].ymin)
          } else {
            startX = boxs[index].xmax
            startY = boxs[index].ymax
            width = Math.abs(boxs[index].xmax - boxs[index].xmin)
            height = Math.abs(boxs[index].ymax - boxs[index].ymin)
          }
          ctx.rect(startX, startY, width, height)
          ctx.font = '30px Arial'
          ctx.fillStyle = 'red'
          if (startX <= 0) {
            ctx.fillText(`${boxs[index].confident}%`, startX, startY + 30)
          } else {
            ctx.fillText(`${boxs[index].confident}%`, startX, startY - 5)
          }
        }
        ctx.stroke()
        document.getElementById('image001').appendChild(canvas)
      }
    }
  }
}
</script>

<style scoped>
.layout-img {
  width: 100%;
}
</style>
